export class Profile {
  profileUuid: string;
  name: string;
  description: string;
  creationDate: string;
  predefined: boolean;
  permissions: Permission[]
}

export class Permission {
  permissionUuid: string;
  name: string;
  description: string;
}
